import { render } from "./App.vue?vue&type=template&id=b9ec7134"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=b9ec7134&lang=sass"
script.render = render

export default script